import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js";

import shoppingModule from "./modules/shoppingModule";
import onBoardingModule from "./modules/onBoardingModule";
import reportModule from "./modules/reportModule";
import jobBrowserModule from "./modules/jobBrowserModule";
import fleetMasterModule from "./modules/fleetMasterModule";
import geofenceModule from "./modules/geofenceModule";
import buyingTariffModule from "./modules/buyingTariffModule";
import sellingTariffModule from "./modules/sellingTariffModule";
import corporateModule from "./modules/corporateModule";
import financeModule from "./modules/financeModule";
import administrationModule from "./modules/administrationModule";
import securityModule from "./modules/securityModule";
import paymentModule from "./modules/paymentModule";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "*",
      name: "404",
      component: () => import("@/components/shared/404")
    },
    {
      path: "",
      component: () => import("@/layouts/AppLayout"),
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import("@/components/availability/Home"),
          meta: {
            title: "Home",
            requiresAuth: true
          }
        },
        {
          path: "/guide",
          name: "Guide",
          component: () => import("@/components/master/guide/Guide"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/profile",
          name: "Profile",
          component: () => import("@/components/shared/Profile"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/logout",
          name: "Logout",
          component: () => import("@/components/shared/Logout")
        },
        {
          path: "/unauthorized",
          name: "401",
          component: () => import("@/components/shared/401")
        },
        {
          path: "/server-error",
          name: "500",
          component: () => import("@/components/shared/500")
        },
        {
          path: "/repricing/:id",
          name: "Repricing",
          component: () => import("@/components/shared/Repricing")
        },
        ...shoppingModule,
        ...onBoardingModule,
        ...reportModule,
        ...jobBrowserModule,
        ...fleetMasterModule,
        ...geofenceModule,
        ...buyingTariffModule,
        ...sellingTariffModule,
        ...corporateModule,
        ...financeModule,
        ...administrationModule,
        ...securityModule,
        ...paymentModule
      ]
    },
    {
      path: "",
      component: () => import("@/layouts/PublicLayout"),
      children: [
        {
          path: "/reservation/:reservation_id/amend/:amendment_id/respond",
          name: "AmendConfirmation",
          component: () =>
            import("@/components/reservation/amend/Confirmation"),
          meta: {
            requiresAuth: false,
            services: []
          }
        },
        {
          path: "/invoices/:invoice_id/pub",
          name: "InvoiceInformation",
          component: () =>
            import("@/components/invoice/PublicInvoiceInformation"),
          meta: {
            requiresAuth: false,
            services: []
          }
        }
      ]
    }
    //   {
    //     path: '/dashboard/tenant',
    //     name: 'TenantDashboard',
    //     component: () => import('@/components/dashboard/TenantDashboard'),
    //     meta: {
    //       title: 'Dashboard Tenant',
    //       requiresAuth: true,    //     }
    //   },
    //   {
    //     path: '/dashboard/provider',
    //     name: 'ProviderDashboard',
    //     component: () => import('@/components/dashboard/ProviderDashboard'),
    //     meta: {
    //       title: 'Dashboard Provider',
    //       requiresAuth: true,    //     }
    //   },
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      to.matched.some(
        record =>
          record.meta.services !== undefined && record.meta.services.length > 0
      )
    ) {
      const profile = await store.dispatch("user/getProfile");
      if (to.meta.services.some(service => profile.services[service])) {
        next();
      } else {
        next("/unauthorized");
      }
    } else {
      // authorization per-components
      next();
    }
  } else {
    // no auth required. We can navigate
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js